import React, { useState, useEffect } from 'react'

import HoverTooltip from '../../../../../../components/HoverTooltip'
import MoneyInput from '../../../../../../components/form/MoneyInput'
import CurrencySelector from '../../../../../../components/currency/CurrencySelector'

import Section from '../../../../../../components/Section'
import { Contract, ContractPerformance } from '../../../types'

import {
    purchaseTypeInfo,
    purchaseInfo,
    planInfo,
    ContractPurchaseInfoError,
} from '../types'

import { CurrencyList } from '../../../../Plans/Positions/Edit/types'

import Checkbox from '../../../../../../components/form/Checkbox'

type Props = {
    theme: string
    contractAction: boolean
    contractGuid: string | undefined
    currencyList: CurrencyList[]
    contractPrice: number | undefined
    contractRubPrice: number | null | undefined
    contractsLoading: boolean
    contractsError: string | null
    contract: Contract
    onNotice44: (notice_44: boolean) => void
    onNotice44Num: (notice_44_num: string | null) => void
    onNotice44Lot: (lot_44_num: string | null) => void
    onNoticeNotPlacedByFz223p5s4: (
        notice_not_placed_by_fz223_p5_s4: boolean
    ) => void
    onEmergency: (emergency: boolean) => void
    onResumeDate: (resume_date: string | null) => void

    onPurchaseInfo: (purchase_info: purchaseInfo) => void
    onPlanInfo: (plan_info: planInfo) => void
    onPurchaseTypeInfo: (purchase_type_info: purchaseTypeInfo) => void
    onDigitalPurchase: (digital_purchase: boolean) => void
    onProvider: (provider: boolean) => void
    onTermination: (termination: boolean) => void
    onExtension: (extension: boolean) => void
    onCustomerAppealedOrNeedsApproval: (
        customer_appealed_or_needs_approval: boolean
    ) => void
    onCustomerApprovalOrAntimonopolyDescisionDate: (
        customer_approval_or_antimonopoly_descision_date: string | null
    ) => void
    errors?: ContractPurchaseInfoError

    onOpenPlanPositionPopup: () => void
    onOpenPurchasePopup: () => void
}

const ContractPurchaseInfo: React.FC<Props> = (props) => {
    const [isChangeNotice44, setChangeNotice44] = useState<boolean>(false)
    const [сhangeNotice44Popup, setChangeNotice44Popup] =
        useState<boolean>(false)
    const [
        сhangeNoticeNotPlacedByFz223p5s4Popup,
        setChangeNoticeNotPlacedByFz223p5s4Popup,
    ] = useState<boolean>(false)

    useEffect(() => {
        console.log(props.contractAction)
    }, [])

    const handleChangeNotice44 = (change: boolean) => {
        if (change) {
            props.onNotice44(!props.contract.notice_44)
            props.onNotice44Num(null)
            props.onNotice44Lot(null)
            props.onNoticeNotPlacedByFz223p5s4(false)
            props.onEmergency(false)
            props.onPurchaseInfo({
                purchase_notice_guid: null,
                purchase_notice_number: null,
                purchase_publication_date_time: null,
                purchase_notice_name: null,
                lot_guid: null,
            })
            props.onPlanInfo({
                plan_registration_number: null,
                plan_guid: null,
                plan_position_number: null,
                plan_position_type: null,
                plan_position_guid: null,
                plan_position_contract_subject: null,
            })
            props.onPurchaseTypeInfo({
                purchase_type_info_code: null,
                purchase_type_info_name: null,
            })
            props.onResumeDate(null)
            props.onDigitalPurchase(false)
            props.onProvider(false)
            props.onTermination(false)
            props.onExtension(false)
            props.onCustomerAppealedOrNeedsApproval(false)
            props.onCustomerApprovalOrAntimonopolyDescisionDate(null)

            setChangeNotice44Popup(!сhangeNotice44Popup)
        } else {
            setChangeNotice44Popup(!сhangeNotice44Popup)
        }
    }

    const handleChangeNoticeNotPlacedByFz223p5s4 = (change: boolean) => {
        if (change) {
            props.onNotice44(false)
            props.onNotice44Num(null)
            props.onNotice44Lot(null)
            props.onNoticeNotPlacedByFz223p5s4(
                !props.contract.notice_not_placed_by_fz223_p5_s4
            )
            props.onEmergency(false)
            props.onPurchaseInfo({
                purchase_notice_guid: null,
                purchase_notice_number: null,
                purchase_publication_date_time: null,
                purchase_notice_name: null,
                lot_guid: null,
            })
            props.onPlanInfo({
                plan_registration_number: null,
                plan_guid: null,
                plan_position_number: null,
                plan_position_type: null,
                plan_position_guid: null,
                plan_position_contract_subject: null,
            })
            props.onPurchaseTypeInfo({
                purchase_type_info_code: null,
                purchase_type_info_name: null,
            })
            props.onResumeDate(null)
            props.onDigitalPurchase(false)
            props.onProvider(false)
            props.onTermination(false)
            props.onExtension(false)
            props.onCustomerAppealedOrNeedsApproval(false)
            props.onCustomerApprovalOrAntimonopolyDescisionDate(null)

            setChangeNoticeNotPlacedByFz223p5s4Popup(
                !сhangeNoticeNotPlacedByFz223p5s4Popup
            )
        } else {
            setChangeNoticeNotPlacedByFz223p5s4Popup(
                !сhangeNoticeNotPlacedByFz223p5s4Popup
            )
        }
    }

    return (
        <Section title="Информация о закупке">
            <fieldset disabled={props.contractAction}>
                <div className="flex flex-col w-full gap-3">
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Извещение по 44-ФЗ"
                                checked={props.contract?.notice_44 ?? false}
                                onChange={() => handleChangeNotice44(false)}
                                disabled={true} //Изменить потом когда появится возможность
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Извещение не размещалось в соответствии с частью 5 статьи 4 Федерального Закона № 223-ФЗ"
                                checked={
                                    props.contract
                                        ?.notice_not_placed_by_fz223_p5_s4 ??
                                    false
                                }
                                onChange={() =>
                                    handleChangeNoticeNotPlacedByFz223p5s4(
                                        false
                                    )
                                }
                                disabled={false} //Изменить потом когда появится возможность
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Закупка осуществляется вследствие аварии, иных чрезвычайных ситуаций природного или техногенного характера, непреодолимой силы, при необходимости срочного медицинского вмешательства, а также для предотвращения угрозы возникновения указанных ситуаций"
                                checked={props.contract?.emergency ?? false}
                                onChange={props.onEmergency}
                                disabled={false}
                            />
                        </div>
                    </div>
                    {props.contract?.notice_44 == false &&
                    props.contract?.notice_not_placed_by_fz223_p5_s4 ==
                        false ? (
                        <>
                            <div className="flex flex-col">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Извещение о закупке{' '}
                                    <span className="text-[#FF0000]">*</span>
                                </label>
                                <div className="relative flex flex-row w-full items-center justify-end">
                                    <input
                                        type="text"
                                        className={`form-input user-input-placeholder w-full  ${
                                            props.errors?.notice_44
                                                ? 'border border-[#C15C5C] rounded-md p-2'
                                                : ''
                                        }`}
                                        value={
                                            props.contract?.purchase_notice_guid
                                                ? props.contract
                                                      ?.purchase_notice_number +
                                                  ' - ' +
                                                  props.contract
                                                      ?.purchase_notice_name
                                                : ''
                                        }
                                        style={{
                                            colorScheme:
                                                props.theme == 'dark'
                                                    ? 'dark'
                                                    : 'light',
                                        }}
                                    />
                                    {!props.contractAction && (
                                        <HoverTooltip
                                            tooltipText="Выбрать извещение о закупке"
                                            align="left"
                                            valign="top"
                                        >
                                            <button
                                                className="absolute flex w-6 h-6 mr-1 rounded-full items-center justify-center bg-[#FFFFFF] hover:bg-[#e4e6e8] dark:bg-[#181818] dark:hover:bg-[#656365]"
                                                onClick={
                                                    props.onOpenPurchasePopup
                                                }
                                            >
                                                {/* иконка */}
                                                <svg
                                                    className="w-3 h-3"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    id="bars"
                                                >
                                                    <path
                                                        fill={
                                                            props.theme ==
                                                            'dark'
                                                                ? '#FFFFFF'
                                                                : '#181818'
                                                        }
                                                        d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                                                    ></path>
                                                </svg>
                                            </button>
                                        </HoverTooltip>
                                    )}
                                </div>
                            </div>
                            <div className="flex flex-col">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Лот
                                </label>
                                <input
                                    type="text"
                                    className={`form-input user-input-placeholder w-full  ${
                                        props.errors?.notice_44
                                            ? 'border border-[#C15C5C] rounded-md p-2'
                                            : ''
                                    }`}
                                    value={
                                        props.contract?.lot_guid
                                            ? (props.contract
                                                  ?.subject_contract ?? '')
                                            : ''
                                    }
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                    readOnly
                                />
                            </div>
                        </>
                    ) : (
                        ''
                    )}

                    {props.contract?.notice_44 ||
                    props.contract?.notice_not_placed_by_fz223_p5_s4 ? (
                        <div className="flex flex-col">
                            <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Позиция плана закупки{' '}
                                <span className="text-[#FF0000]">*</span>
                            </label>
                            <div className="relative flex flex-row w-full items-center justify-end">
                                <input
                                    type="text"
                                    className={`form-input user-input-placeholder w-full  ${
                                        props.errors?.notice_44
                                            ? 'border border-[#C15C5C] rounded-md p-2'
                                            : ''
                                    }`}
                                    value={
                                        props.contract?.plan_registration_number
                                            ? '№ ' +
                                              props.contract
                                                  ?.plan_position_number +
                                              ' - ' +
                                              props.contract
                                                  ?.plan_position_contract_subject +
                                              ', План закупки № ' +
                                              props.contract
                                                  ?.plan_registration_number
                                            : ''
                                    }
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                    readOnly
                                />
                                {!props.contractAction && (
                                    <HoverTooltip
                                        tooltipText="Выбрать позицию из плана"
                                        align="left"
                                        valign="top"
                                    >
                                        <button
                                            className="absolute flex w-6 h-6 mr-1 rounded-full items-center justify-center bg-[#FFFFFF] hover:bg-[#e4e6e8] dark:bg-[#181818] dark:hover:bg-[#656365]"
                                            onClick={
                                                props.onOpenPlanPositionPopup
                                            }
                                        >
                                            {/* иконка */}
                                            <svg
                                                className="w-3 h-3"
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                id="bars"
                                            >
                                                <path
                                                    fill={
                                                        props.theme == 'dark'
                                                            ? '#FFFFFF'
                                                            : '#181818'
                                                    }
                                                    d="M3,8H21a1,1,0,0,0,0-2H3A1,1,0,0,0,3,8Zm18,8H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Zm0-5H3a1,1,0,0,0,0,2H21a1,1,0,0,0,0-2Z"
                                                ></path>
                                            </svg>
                                        </button>
                                    </HoverTooltip>
                                )}
                            </div>
                        </div>
                    ) : (
                        ''
                    )}

                    {props.contract?.notice_44 ? (
                        <>
                            <div className="flex flex-col">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Номер извещения закупки по 44-ФЗ
                                </label>
                                <input
                                    type="text"
                                    className={`form-input user-input-placeholder w-full  ${
                                        props.errors?.notice_44
                                            ? 'border border-[#C15C5C] rounded-md p-2'
                                            : ''
                                    }`}
                                    value={props.contract?.notice_44_num ?? ''}
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                    onChange={(e) => {
                                        e.target.value == ''
                                            ? props.onNotice44Num(null)
                                            : props.onNotice44Num(
                                                  e.target.value
                                              )
                                    }}
                                />
                            </div>
                            <div className="flex flex-col">
                                <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                    Номер лота извещения закупки по 44-ФЗ
                                </label>
                                <input
                                    type="text"
                                    className={`form-input user-input-placeholder w-full  ${
                                        props.errors?.notice_44
                                            ? 'border border-[#C15C5C] rounded-md p-2'
                                            : ''
                                    }`}
                                    value={props.contract?.lot_44_num ?? ''}
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                    onChange={(e) => {
                                        e.target.value == ''
                                            ? props.onNotice44Lot(null)
                                            : props.onNotice44Lot(
                                                  e.target.value
                                              )
                                    }}
                                />
                            </div>
                        </>
                    ) : (
                        ''
                    )}

                    <div className="flex flex-col">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Способ закупки{' '}
                            <span className="text-[#FF0000]">*</span>
                        </label>
                        <input
                            type="text"
                            className={`form-input user-input-placeholder w-full  ${
                                props.errors?.notice_44
                                    ? 'border border-[#C15C5C] rounded-md p-2'
                                    : ''
                            }`}
                            value={
                                props.contract?.purchase_type_info_code
                                    ? props.contract?.purchase_type_info_name
                                        ? props.contract
                                              ?.purchase_type_info_name
                                        : ''
                                    : ''
                            }
                            style={{
                                colorScheme:
                                    props.theme == 'dark' ? 'dark' : 'light',
                            }}
                            disabled={true}
                        />
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Закупка была осуществлена в электронной форме"
                                checked={
                                    props.contract?.digital_purchase ?? false
                                }
                                onChange={props.onDigitalPurchase}
                                disabled={true} //Нельзя внести изменения потому, что он зависит от способа закупки в плане закупок или извещения
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Закупка у субъекта малого и среднего предпринимательства, в том числе закупка, участниками которой являются только субъекты малого и среднего предпринимательства"
                                checked={props.contract?.provider ?? false}
                                onChange={props.onProvider}
                                disabled={true} //Нельзя внести изменения потому, что он зависит от способа закупки в плане закупок или извещения
                            />
                        </div>
                    </div>
                    <div className="flex flex-col">
                        <label className="w-full text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                            Дата подведения итогов закупки{' '}
                            {/* <span className="text-[#FF0000]">*</span> */}
                        </label>
                        <HoverTooltip
                            tooltipText={props.errors?.resume_date || ''}
                        >
                            <input
                                type="date"
                                className={`form-input user-input-placeholder w-[200px]  ${
                                    props.errors?.resume_date
                                        ? 'border border-[#C15C5C] rounded-md p-2'
                                        : ''
                                }`}
                                value={props.contract?.resume_date ?? ''}
                                onChange={(e) => {
                                    e.target.value == ''
                                        ? props.onResumeDate(null)
                                        : props.onResumeDate(e.target.value)
                                }}
                                style={{
                                    colorScheme:
                                        props.theme == 'dark'
                                            ? 'dark'
                                            : 'light',
                                }}
                            />
                        </HoverTooltip>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Договором предусмотрено прекращение обязательств сторон по договору в связи с окончанием срока действия договора"
                                checked={props.contract?.termination ?? false}
                                onChange={props.onTermination}
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Договором предусмотрена возможность продления срока действия договора после его окончания"
                                checked={props.contract?.extension ?? false}
                                onChange={props.onExtension}
                                disabled={false}
                            />
                        </div>
                    </div>
                    <div className="flex flex-col w-full gap-x-5 ">
                        <div className="flex flex-col min-w-[200px]">
                            <Checkbox
                                label="Действия (бездействия) заказчика обжалованы в антимонопольном органе или существует необходимость одобрения органом управления заказчика в соответствии с законодательством Российской Федерации заключения договора"
                                checked={
                                    props.contract
                                        ?.customer_appealed_or_needs_approval ??
                                    false
                                }
                                onChange={
                                    props.onCustomerAppealedOrNeedsApproval
                                }
                                disabled={false}
                            />
                        </div>
                    </div>
                    {props.contract?.customer_appealed_or_needs_approval ? (
                        <div className="flex flex-col">
                            <label className="w-full mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                                Дата одобрения органом управления заказчика или
                                вынесения решения антимонопольного органа{' '}
                                <span className="text-[#FF0000]">*</span>
                            </label>
                            <HoverTooltip
                                tooltipText={
                                    props.errors
                                        ?.customer_approval_or_antimonopoly_descision_date ||
                                    ''
                                }
                            >
                                <input
                                    type="date"
                                    className={`form-input user-input-placeholder w-[200px]  ${
                                        props.errors
                                            ?.customer_approval_or_antimonopoly_descision_date
                                            ? 'border border-[#C15C5C] rounded-md p-2'
                                            : ''
                                    }`}
                                    value={
                                        props.contract
                                            ?.customer_approval_or_antimonopoly_descision_date ??
                                        ''
                                    }
                                    onChange={(e) => {
                                        e.target.value == ''
                                            ? props.onCustomerApprovalOrAntimonopolyDescisionDate(
                                                  null
                                              )
                                            : props.onCustomerApprovalOrAntimonopolyDescisionDate(
                                                  e.target.value
                                              )
                                    }}
                                    style={{
                                        colorScheme:
                                            props.theme == 'dark'
                                                ? 'dark'
                                                : 'light',
                                    }}
                                />
                            </HoverTooltip>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            </fieldset>
            {сhangeNotice44Popup && (
                <div className="fixed top-0 left-0 w-full h-full bg-[#00000050] flex justify-center items-center">
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[370px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-col text-sm text-[#181818] dark:text-[#FFFFFF] items-center justify-center gap-5">
                            <div className="flex flex-col">
                                <label className="flex mb-1 text-sm text-[#181818] dark:text-[#FFFFFF]">
                                    При изменении значения «Извещение по 44-ФЗ»
                                    все ранее введенные данные будут утеряны
                                </label>
                            </div>
                            <div className="flex w-full flex-row items-center justify-end gap-3">
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={() => {
                                        handleChangeNotice44(false)
                                    }}
                                >
                                    Отмена
                                </button>
                                <button
                                    className="flex px-4 py-1 min-w-[120px] h-6 rounded-[10px] items-center justify-center text-xs shadow-md shadow-[#18181830] text-[#181818] bg-[#ed9cae] hover:bg-[#ffa7ba] dark:bg-[#701F1F] dark:hover:bg-[#9e2c2c] dark:text-[#FFFFFF]"
                                    onClick={() => {
                                        handleChangeNotice44(true)
                                    }}
                                >
                                    Изменить
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {сhangeNoticeNotPlacedByFz223p5s4Popup && (
                <div className="fixed top-0 left-0 w-full h-full bg-[#00000050] flex justify-center items-center">
                    <div
                        className="p-5 rounded-lg bg-[#e5e5e5] dark:bg-[#262427] w-[500px] max-h-[600px]"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex flex-col text-sm text-[#181818] dark:text-[#FFFFFF] items-center justify-center gap-5">
                            <div className="flex flex-col">
                                <label className="flex mb-1 text-sm text-[#181818] dark:text-[#FFFFFF]">
                                    При изменении значения «Извещение не
                                    размещалось в соответствии с частью 5 статьи
                                    4 Федерального Закона № 223-ФЗ» все ранее
                                    введенные данные будут утеряны
                                </label>
                            </div>
                            <div className="flex w-full flex-row items-center justify-end gap-3">
                                <button
                                    className="flex flex-row min-w-[120px] h-6 px-4 rounded-[10px] justify-center items-center gap-2 text-xs shadow-md shadow-[#18181830] text-[#181818] dark:text-[#FFFFFF] bg-[#f6f6f6] dark:bg-[#494849] hover:bg-[#FFFFFF] dark:hover:bg-[#656365]"
                                    onClick={() => {
                                        handleChangeNoticeNotPlacedByFz223p5s4(
                                            false
                                        )
                                    }}
                                >
                                    Отмена
                                </button>
                                <button
                                    className="flex px-4 py-1 min-w-[120px] h-6 rounded-[10px] items-center justify-center text-xs shadow-md shadow-[#18181830] text-[#181818] bg-[#ed9cae] hover:bg-[#ffa7ba] dark:bg-[#701F1F] dark:hover:bg-[#9e2c2c] dark:text-[#FFFFFF]"
                                    onClick={() => {
                                        handleChangeNoticeNotPlacedByFz223p5s4(
                                            true
                                        )
                                    }}
                                >
                                    Изменить
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Section>
    )
}

export default ContractPurchaseInfo
